import { FC } from 'react';
import { RichTextEditor, TextInput, TextInputSizes } from '@silverfort/sf-components';
import { Controller, useFormContext } from 'react-hook-form';
import { EnrollmentEmailFormValues } from '../../../../types/forms';
import { ToolbarItemKey } from '@silverfort/sf-components/dist/RichTextEditor/types';
import { MAIL_CONTENT_CHARS_LIMIT } from '../../consts';
import { getTextContentFromMarkdown } from '../../utils';

export interface Props {
    visibleToolbarItems: ToolbarItemKey[];
    defaultEmailContent?: string;
    defaultEmailTitle?: string;
    onChange: (key: keyof EnrollmentEmailFormValues, value: string) => void;
}

export const EmailContentSection: FC<Props> = ({
    visibleToolbarItems,
    defaultEmailContent,
    defaultEmailTitle,
    onChange
}) => {
    const { control } = useFormContext<EnrollmentEmailFormValues>();

    return (
        <>
            <div className="flex flex-row justify-between items-center mt-4 mb-1">
                <div className="text-13 font-medium">Email content</div>
            </div>
            <div className="h-auto flex-shrink-0 flex flex-col gap-4 justify-start bg-sf-gray-50 rounded-lg p-6">
                <Controller
                    name="subject"
                    control={control}
                    render={({ field: { value } }) => (
                        <TextInput
                            inputSize={TextInputSizes.Large}
                            className="!bg-transparent w-full"
                            onChange={(value) => {
                                onChange('subject', value);
                            }}
                            value={value}
                            placeholder="Please enter subject"
                        />
                    )}
                />
                <Controller
                    name="content"
                    control={control}
                    render={({ field: { value } }) => {
                        const length = value ? getTextContentFromMarkdown(value).length : 0;

                        return (
                            <div className="flex flex-col gap-2">
                                <RichTextEditor
                                    value={value}
                                    onChange={(value) => {
                                        onChange('content', value);
                                    }}
                                    tokenProps={{
                                        list: ['{user-name}', '{company-name}', '{company-email-domain}'],
                                        color: '#A5A5A5'
                                    }}
                                    toolbarConfig={{ visible: visibleToolbarItems }}
                                    contentClassName="h-[300px] overflow-y-auto"
                                    defaultValue={defaultEmailContent}
                                    onResetClick={() => {
                                        onChange('subject', defaultEmailTitle || '');
                                    }}
                                />
                                <span
                                    className={`font-sf text-13 leading-[19px] tracking-[0.203px] ${
                                        length <= MAIL_CONTENT_CHARS_LIMIT ? 'text-sf-gray-500' : 'text-sf-error'
                                    } `}>
                                    {length}/{MAIL_CONTENT_CHARS_LIMIT} Characters
                                </span>
                            </div>
                        );
                    }}
                />
            </div>
        </>
    );
};
